function getAliaDiscountData() {
  try {
    let actions = JSON.parse(sessionStorage.getItem('alia-user-actions') || '[]');
    if (actions.length == 0) {
        actions = JSON.parse(localStorage.getItem('alia-user-actions') || '[]');
    }
    let percent = null;
    let code = null;

    actions.forEach(a => {
      if (a.type === 'setProperty') {
        const key = a.data?.property?.toLowerCase();

        if (key.includes('percent')) percent = a.data.value;
        if (key.includes('coupon') || key.includes('code')) code = a.data.value;
      }
    });

    return { percent, code };
  } catch {
    return {};
  }
}

// The width range where the banner stays hidden and the announcement bar carries
// the offer instead — kept in step with the media query in main.css
const ALIA_ANNOUNCEMENT_QUERY = '(min-width: 769px) and (max-width: 1199px)';

function setAliaBannerHeight() {
  const banner = document.querySelector('.alia-just-for-you');
  const height = banner && !banner.classList.contains('hidden') ? banner.offsetHeight : 0;

  document.documentElement.style.setProperty('--alia-banner-height', `${height}px`);
}

// The copy wraps to two lines on narrow screens, so the height can't be assumed
function observeAliaBannerHeight() {
  const banner = document.querySelector('.alia-just-for-you');

  if (!banner || banner.dataset.heightObserved) return;

  banner.dataset.heightObserved = 'true';
  new ResizeObserver(setAliaBannerHeight).observe(banner);
}

function aliaBannerIsClosed() {
  try {
    return sessionStorage.getItem('alia_banner_closed') === 'true';
  } catch {
    return false;
  }
}

document.addEventListener('click', function (e) {
  if (e.target.closest('.alia-just-for-you__close')) {
    const banner = document.querySelector('.alia-just-for-you');

    if (banner) banner.classList.add('hidden');

    sessionStorage.setItem('alia_banner_closed', 'true');
    setAliaBannerHeight();
  }
});

window.updateDiscountUI = function () {
  const { percent, code } = getAliaDiscountData();

  if (!percent && !code) return;

  // Badge
  document.querySelectorAll('.alia-discount-badge').forEach(el => {
    if (percent) el.textContent = `${percent}% OFF`;
    el.classList.remove('hidden');
  });

  // Info banner
  document.querySelectorAll('.alia-discount-info').forEach(el => {
    if (percent && code) {
      el.innerHTML = `<span class="discount-off">${percent}%</span> off sitewide with code <strong>${code}</strong>`;
    }
    el.classList.remove('hidden');
  });

  // Product Cards
  document.querySelectorAll('.product-label--alia').forEach(el => {
    if (percent) el.textContent = `${percent}% OFF`;
    el.classList.remove('hidden');
  });

  // Just for you banner — on mobile it sits under the nav, so the USP announcement
  // bar above it keeps its own copy and stays non-sticky.
  const banner = document.querySelector('.alia-just-for-you');
  const text = document.querySelector('.alia-offer-text');

  if (banner && text) {
    text.innerHTML = `Save ${percent}% sitewide. Use Code: <strong>${code}</strong>`;

    if (!aliaBannerIsClosed()) {
      banner.classList.remove('hidden');
    }
  }

  setAliaBannerHeight();
  observeAliaBannerHeight();

  // Only where the banner itself is hidden does the announcement bar stand in for it
  const useAnnouncementBar = window.matchMedia(ALIA_ANNOUNCEMENT_QUERY).matches;

  document.querySelectorAll('.announcement__text--discount .rte').forEach(el => {
    if (!el.dataset.originalText) {
      el.dataset.originalText = el.innerHTML;
    }

    if (useAnnouncementBar) {
      el.innerHTML = `
        <p>
          <strong>Welcome Offer:</strong>
          Save ${percent}% sitewide. Use Code: <strong>${code}</strong>
        </p>
      `;
    } else {
      el.innerHTML = el.dataset.originalText;
    }
  });
};

// Crossing the breakpoint swaps which of the two carries the offer
window.matchMedia(ALIA_ANNOUNCEMENT_QUERY).addEventListener('change', () => {
  window.updateDiscountUI();
});

document.addEventListener('DOMContentLoaded', () => {
  window.updateDiscountUI();
});